import React from 'react'
// libs
import { useSnackbar } from 'notistack'
import { useSubscription } from '@apollo/client/react'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
import { useApolloClient } from 'hooks/useApolloClient'
// graphql
import { APP_NOTIFICATION } from 'graphql/notifications/subscriptions'
// types
import { INotification } from 'types/graphql'
import { NotificationType } from 'constants/notifications'
// utils
import { getSnackbarCloseButton } from 'providers/SnackbarProvider/utils'

export const useAppNotifications = () => {
  const { client } = useApolloClient()

  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const { id: userId, company } = useCurrentUser()

  const { data: subscriptionData } = useSubscription<{ notification: INotification }>(APP_NOTIFICATION, {
    shouldResubscribe: true,
    skip: !userId,
    variables: { eventType: userId }
  })

  React.useEffect(() => {
    const notification = subscriptionData?.notification?.payload

    if (!notification) {
      return
    }

    if (notification.notificationType === NotificationType.PlanCloneCompleted) {
      const openClonedPlan = () => window.open(`/plans/${company.id}/edit/${notification.planId}`, '_blank')

      enqueueSnackbar('Plan has been cloned', {
        variant: 'success',
        hideIconVariant: true,
        autoHideDuration: 10000,
        action: (key) => getSnackbarCloseButton(key, closeSnackbar, 'OPEN', openClonedPlan)
      })

      client.refetchQueries({ include: ['PLANS_LIST_QUERY'] })
    }
  }, [subscriptionData])
}
